import { createTheme, type MantineColorsTuple } from '@mantine/core';

const brand: MantineColorsTuple = [
  '#eef3ff', '#dce4f5', '#b9c7e2', '#94a8d0', '#748dc0',
  '#5f7cb7', '#5474b4', '#44639f', '#3a5890', '#2c4b81',
];

export const theme = createTheme({
  primaryColor: 'brand',
  // Index 6 in light mode is too pale against white for filled buttons.
  primaryShade: { light: 7, dark: 5 },
  colors: { brand },
  defaultRadius: 'md',
  fontFamily: 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif',
  fontFamilyMonospace: 'ui-monospace, SFMono-Regular, "Cascadia Code", Consolas, monospace',
  headings: { fontWeight: '650' },
  respectReducedMotion: true,
  components: {
    Card: { defaultProps: { withBorder: true, padding: 'lg', radius: 'md' } },
    Table: { defaultProps: { highlightOnHover: true, verticalSpacing: 'sm' } },
    Button: { defaultProps: { fw: 550 } },
    Badge: { defaultProps: { fw: 600 } },
    Tooltip: { defaultProps: { withArrow: true, openDelay: 250 } },
    Anchor: { defaultProps: { underline: 'hover' } },
  },
});
